<template>
  <div>
    <b-card>
      <modals-container v-model="items" />

      <template>
        <mdb-container>
          <mdb-modal
            :show="confirmar"
            @close="confirmar = false"
            size="sm"
            class="text-center"
            style="top:40px;"
            danger
          >
            <mdb-modal-header center :close="false">
              <p
                class="heading"
              >Confirmar que quieres eliminar la audiencia {{audienciaSelected.name}}</p>
            </mdb-modal-header>
            <mdb-modal-body>
              <mdb-icon icon="times" size="4x" class="animated rotateIn" />
            </mdb-modal-body>
            <mdb-modal-footer center>
              <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
              <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
            </mdb-modal-footer>
          </mdb-modal>
        </mdb-container>
      </template>

      <template>
        <mdb-modal :show="modal" @close="modal = false" fullHeight info removeBackdrop>
          <mdb-modal-header center :close="false">
            <p class="heading lead">{{ modalName}} audiencia</p>
          </mdb-modal-header>
          <mdb-modal-body class="modal-body">
            <modal-create-audiencia :onClick="closeModalCreate" v-if="modalName=='Crear'"></modal-create-audiencia>
            <modal-edit-audiencia
              :onClick="closeModalCreate"
              :audiencia="audienciaSelected"
              v-if="modalName=='Editar'"
            ></modal-edit-audiencia>
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="modal = false">Cancelar</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </template>

      <b-btn variant="primary" class="p-2 mb-4" @click="openModal('Crear')">
        <i class="far fa-edit mr-1"></i>
        Nueva audiencia
      </b-btn>
      <div slot="header" v-html="caption"></div>
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        :items="items"
        :fields="captions"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="acciones" slot-scope="data">
          <b-row>
            <div class="seleccionar col-3">
              <b-badge variant="primary" class="p-2" @click="selectAudienciaEdit(data.item,items)">
                <i class="far fa-edit mr-1"></i>Editar
              </b-badge>
            </div>
            <div class="seleccionar col-2">
              <b-badge variant="danger" class="p-2" @click="selectAudienciaDelete(data.item)">
                <i class="far fa-trash-alt mr-1"></i>Eliminar
              </b-badge>
            </div>
          </b-row>
        </template>
      </b-table>
      <nav>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />
      </nav>
    </b-card>
  </div>
</template>

<script>
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import ModalCreateAudiencia from "../notifications/ModalCreateAudiencia";
import ModalEditAudiencia from "../notifications/ModalEditAudiencia";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";
export default {
  name: "table-audiencia",
  inheritAttrs: false,
  components: {
    ModalCreateAudiencia,
    ModalEditAudiencia,
    mdbContainer,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      modal: false,
      modalName: "",
      isLoadingLine: false,
      confirmar: false,
      audienciaSelected: {}
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    openModal(opcion) {
      this.modalName = opcion;
      this.modal = true;
    },
    createAudiencia() {
      this.modalName = "Crear";
      this.modal = true;
    },
    selectAudienciaEdit(item, items) {
      this.audienciaSelected = item;
      this.modalName = "Editar";
      this.modal = true;
    },
    selectAudienciaDelete(item) {
      this.audienciaSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    closeModalCreate() {
      this.modal = false;
    },
    eliminar() {
      setTimeout(() => {
        store.dispatch("deleteAudienciaUtility", this.audienciaSelected.id);
      }, 400);
      store.dispatch("deleteAudiencia", this.audienciaSelected.id);
      this.confirmar = false;
    }
  }
};
</script>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}
</style>
